// extracted by mini-css-extract-plugin
module.exports = {"container":"cP","imgContainer":"dP","content":"eP","brand":"fP","product":"gP","price":"hP","noLink":"iP"};